const linearGradientHitractGradient = "linear-gradient(+45deg,#0798ed,#8ae6da)"

const colorHitractFadeShadow = {
    boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(7, 151, 237, 0.4)",
    background: "linear-gradient(+45deg,#0798ed,#8ae6da)"
}

const colorHitractGradient = {
    background: "linear-gradient(+45deg,#0798ed,#8ae6da)"
}

const backgroundColorHitractGradient = "linear-gradient(+45deg,#0798ed,#8ae6da)"

const hitractTagColor = 'rgb(41,172,232)';

export {
    colorHitractFadeShadow,    
    colorHitractGradient,
    linearGradientHitractGradient,
    hitractTagColor,
    backgroundColorHitractGradient
};
  